import React from 'react';

const isUndefined = (v) => v === undefined;

const allDefined = (mandatory, props) =>
  mandatory.map((k) => props[k]).findIndex(isUndefined) === -1;

export default (mandatory) => (Component) => (props) =>
  allDefined(mandatory, props) ? <Component {...props} /> : null;
